import { FormDateTimeInput } from '@nexelem/form-components';
import { ParameterLabel } from './ParameterLabel';

type DateParameterProps = {
  name: string;
  label: string;
  required: boolean;
};

export const DateParameter = ({ name, label, required }: DateParameterProps) => {
  return (
    <div className="flex min-h-8 items-center gap-6">
      <ParameterLabel label={label} required={required} />
      <FormDateTimeInput
        className="[&>div]:gap-2 [&>div>div:first-child]:w-44 [&>div>div:first-child]:shrink-0 [&>div>div:last-child]:w-22 [&>div>div:last-child]:shrink-0 [&>div:nth-child(2)]:hidden"
        dateLabel=""
        name={name}
        required={required}
        size="small"
        timeLabel=""
      />
    </div>
  );
};
